const trans_ar = {
  // Form Fields
  name: "الاسم",
  first_name: "الاسم الأول",
  last_name: "اسم العائلة",
  name_ar: "الاسم باللغة العربية",
  name_en: "الاسم باللغة الإنجليزية",
  price: "السعر",
  email: "البريد الإلكتروني",
  password: "كلمة المرور",
  confirm_password: "تأكيد كلمة المرور",
  phone_number: "رقم الهاتف",
  business_name: "اسم المنشأة",
  business_type: "نوع المنشأة",
  shop_address: "عنوان المحل",
  cr_number: "رقم السجل التجاري",
  vat_number: "الرقم الضريبي",
  business_logo: "شعار المنشأة",
  image: "الصورة",
  is_taxable: "خاضع للضريبة",
  is_refunded: "مسترجع",
  is_qr_product: "منتج برمز QR",
  is_stockable: "قابل للتخزين",
  reset: "إعادة ضبط",
  cart: "السلة",
  address: "العنوان",
  company: "شركة",
  individual: "فرد",
  code: "الرمز",
  branch_code: "رمز الفرع",
  branch: "الفرع",
  active: "نشط",
  inactive: "غير نشط",
  subscribe: "اشتراك",
  unsubscribe: "إلغاء الاشتراك",
  no_of_employees: "عدد الموظفين",
  no_of_licenses: "عدد التراخيص",
  vat_certificate: "شهادة ضريبة القيمة المضافة",
  cr_certificate: "شهادة السجل التجاري",
  change: "تغيير",
  preview: "معاينة",
  save: "حفظ",
  add_license: "إضافة ترخيص",
  purchase_license: "شراء ترخيص",
  add_free_license: "إضافة ترخيص مجاني",
  buy_more_license: "اشترِ المزيد من التراخيص!",
  buy_more_license_error:
    "يرجى شراء المزيد من التراخيص لإنشاء مستخدمين إضافيين",
  buyer_company_name: "اسم شركة المشتري",
  buyer_company_vat: "الرقم الضريبي لشركة المشتري",
  city: "المدينة",
  region: "المنطقة",
  country: "الدولة",
  postal_code: "الرمز البريدي",
  description: "الوصف",
  attachment: "المرفق",
  no_attachment: "لا يوجد مرفق",
  url: "الرابط (URL)",
  secret_key: "المفتاح السري",
  integration_type: "نوع الربط / التكامل",
  customer_name: "اسم العميل",
  vehicle_number: "رقم المركبة",
  vehicle_color: "لون المركبة",
  reseller_number: "رقم الموزع",
  type: "النوع",
  street: "الشارع",
  building_number: "رقم المبنى",
  plot_id_number: "رقم قطعة الأرض",
  expiry_date: "تاريخ الانتهاء",

  // Form Validations
  validate_preferred_contact_time_required: "يرجى اختيار وقت الاتصال المفضل.",
  validate_email_required: "حقل البريد الإلكتروني مطلوب.",
  validate_email_invalid: "المدخلات ليست بريدًا إلكترونيًا صالحًا!",
  validate_password_required: "حقل كلمة المرور مطلوب.",
  validate_password_min_characters:
    "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
  validate_password_confirm_not_matched: "كلمة المرور غير متطابقة.",
  validate_name_required: "حقل الاسم مطلوب.",
  validate_name_min_characters: "يجب أن يتكون الاسم من 3 أحرف على الأقل.",
  validate_first_name_required: "حقل الاسم الأول مطلوب.",
  validate_first_name_min_characters:
    "يجب أن يتكون الاسم الأول من 3 أحرف على الأقل.",
  validate_last_name_required: "حقل اسم العائلة مطلوب.",
  validate_last_name_min_characters:
    "يجب أن يتكون اسم العائلة من 3 أحرف على الأقل.",
  validate_phone_required: "حقل رقم الهاتف مطلوب.",
  validate_phone_exact_limit: "يجب أن يتكون رقم الهاتف من 12 رقمًا تمامًا.",
  validate_business_name_required: "حقل اسم المنشأة مطلوب.",
  validate_business_type_required: "يرجى تحديد نوع المنشأة.",
  validate_cr_number_required: "رقم السجل التجاري مطلوب.",
  validate_cr_number_exact_limit:
    "يجب أن يتكون رقم السجل التجاري من 10 أرقام تمامًا.",
  validate_vat_number_required: "الرقم الضريبي مطلوب.",
  validate_vat_number_exact_limit:
    "يجب أن يتكون الرقم الضريبي من 15 رقمًا تمامًا.",
  validate_city_required: "حقل المدينة مطلوب.",
  validate_region_required: "حقل المنطقة مطلوب.",
  validate_country_required: "حقل الدولة مطلوب.",
  validate_postal_code_required: "حقل الرمز البريدي مطلوب.",
  validate_postal_code_5digits: "يجب أن يتكون الرمز البريدي من 5 أرقام تمامًا.",
  validate_address: "حقل العنوان مطلوب.",
  validate_shop_address_required: "يرجى إدخال عنوان المحل!",
  validate_image_file_type: "يمكنك تحميل ملفات JPG/PNG فقط!",
  validate_photo_file_type:
    "يجب أن تكون الصورة من نوع JPEG أو PNG أو JPG أو GIF أو SVG!",
  validate_image_size: "يجب أن يكون حجم الصورة أقل من 2 ميجابايت!",
  validate_business_logo_required: "شعار المنشأة مطلوب!",
  validate_image_pdf_file_type: "يمكنك تحميل ملفات JPG/PNG أو PDF فقط!",
  validate_image_size_10: "يجب أن يكون حجم الصورة أقل من 10 ميجابايت!",
  validate_cr_certificate_required: "شهادة السجل التجاري مطلوبة!",
  validate_vat_certificate_required: "شهادة ضريبة القيمة المضافة مطلوبة!",
  validate_type_required: "حقل النوع مطلوب.",
  validate_excel_file_type: "يمكنك تحميل ملفات Excel فقط!",
  validate_file_size_1: "يجب أن يكون حجم الملف أقل من 1 ميجابايت!",
  validate_attachment_required: "حقل المرفق مطلوب!",
  validate_product_name_required: "يرجى إدخال اسم المنتج!",
  validate_product_price_required: "يرجى إدخال سعر المنتج!",
  validate_product_barcode_required: "يرجى إدخال باركود المنتج!",
  validate_product_category_required: "يرجى تحديد فئة المنتج!",
  validate_product_unit_required: "يرجى تحديد وحدة المنتج!",
  validate_product_option_required: "يرجى تحديد خيار المنتج!",
  validate_address_required: "يرجى إدخال عنوان المحل!",
  validate_branch_required: "يرجى تحديد الفرع!",
  validate_description_required: "حقل الوصف مطلوب.",
  validate_cash_required: "حقل النقد مطلوب.",
  validate_card_required: "حقل البطاقة مطلوب.",
  validate_reference_required: "حقل الرقم المرجعي مطلوب.",
  validate_discount_required: "نسبة الخصم مطلوبة.",
  validate_url_required: "حقل الرابط (URL) مطلوب.",
  validate_url_invalid: "المدخلات ليست رابطاً (URL) صالحاً!",
  validate_secret_key_required: "حقل المفتاح السري مطلوب.",
  validate_integration_type_required: "نوع الربط مطلوب.",
  validate_date_required: "حقل التاريخ مطلوب.",
  validate_customer_name_required: "حقل اسم العميل مطلوب.",
  validate_vehicle_number_required: "حقل رقم المركبة مطلوب.",
  validate_vehicle_color_required: "حقل لون المركبة مطلوب.",
  validate_street_required: "حقل الشارع مطلوب.",
  validate_building_number_required: "حقل رقم المبنى مطلوب.",
  validate_plot_id_number_required: "حقل رقم قطعة الأرض مطلوب.",
  validate_entity_required: "هذا الحقل مطلوب.",
  validate_value_required: "حقل القيمة مطلوب.",
  validate_low_stock_required: "حقل المخزون المنخفض مطلوب.",
  validate_expiry_date_required: "حقل تاريخ الانتهاء مطلوب.",
  validate_calories_info_required: "معلومات السعرات الحرارية مطلوبة.",
  validate_street_name_required: "حقل اسم الشارع مطلوب.",
  validate_building_number_4digits:
    "يجب أن يتكون رقم المبنى من 4 أرقام تمامًا.",
  validate_plot_identification_required: "حقل رقم قطعة الأرض مطلوب.",
  validate_plot_identification_4digits:
    "يجب أن يتكون رقم قطعة الأرض من 4 أرقام تمامًا.",
  validate_district_required: "حقل الحي مطلوب.",
  validate_environment_required: "يرجى اختيار البيئة.",
  validate_otp_required: "يرجى إدخال رمز التحقق (OTP).",
  validate_otp_6_digits: "يجب أن يتكون رمز التحقق من 6 أرقام تمامًا.",
  validate_buyer_company_name_required: "اسم شركة المشتري مطلوب.",
  validate_buyer_company_vat_required: "الرقم الضريبي لشركة المشتري مطلوب.",
  validate_buyer_company_address_required: "عنوان شركة المشتري مطلوب.",
  validate_arabic_name_required: "الاسم باللغة العربية مطلوب.",
  validate_sa_vat_number:
    "يجب أن يتكون الرقم الضريبي من 15 رقمًا ويبدأ وينتهي بالرقم 3.",

  // Login
  dont_have_account: "ليس لديك حساب؟",
  login: "تسجيل الدخول",
  visit_website: "زيارة الموقع الإلكتروني",
  website: "موقع إلكتروني",

  // Register
  already_have_an_account: "لديك حساب بالفعل؟",
  sign_in: "تسجيل الدخول",
  sign_up: "إنشاء حساب",
  register_successfully: "تم تسجيلك بنجاح!",
  selected_plan: "الخطة المختارة",
  account_successfully_created: "تم إنشاء حسابك بنجاح!",
  details_activate_company: "املأ التفاصيل لتفعيل منشأتك أو تخطى الآن.",

  // Forgot
  forgot: "نسيت كلمة المرور",
  send_otp: "إرسال رمز التحقق",
  verify_otp: "التحقق من الرمز",
  reset_password: "إعادة تعيين كلمة المرور",
  reset_password_successfully: "تم إعادة تعيين كلمة المرور بنجاح!",

  // Pricing
  daily: "يومي",
  trial: "تجريبي",

  // otp form
  opt_message:
    "تم إرسال رسالة برمز التحقق (OTP) إلى رقم هاتفك المحمول. يرجى ملء الحقل أدناه والتحقق.",
  if_you_want_to_change_phone_number: "إذا كنت تريد تغيير رقم الهاتف",
  click_here: "اضغط هنا.",
  resend_code: "إعادة إرسال الرمز",
  enable_in: "التفعيل خلال",
  validate: "تحقق",
  otp_sent_successfully: "تم إرسال رمز التحقق بنجاح",
  otp_verified: "تم التحقق من الرمز بنجاح",

  // Store Configuration
  shop_configuration_successfully: "تم إكمال تهيئة المتجر بنجاح.",
  allow_round_off: "السماح بتقريب الأرقام لخانة ثنائية",
  preferred_contact_time: "وقت الاتصال المفضل",

  // Menus
  home: "الرئيسية",
  pos: "نقطة البيع (POS)",
  products_list: "قائمة المنتجات",
  products: "المنتجات",
  categories: "الفئات",
  units: "الوحدات",
  options: "الخيارات",
  transactions: "العمليات / المعاملات",
  reports: "التقارير",
  sales_summary: "ملخص المبيعات",
  sales_by_items: "المبيعات حسب العناصر",
  sales_by_categories: "المبيعات حسب الفئات",
  refunds_by_items: "المرتجعات حسب العناصر",
  refunds_by_categories: "المرتجعات حسب الفئات",
  report_by_branch: "التقرير حسب الفرع",
  store_configuration: "تهيئة المتجر",
  subscriptions: "الاشتراكات",
  branches: "الفروع",
  orders: "الطلبات",
  view_order: "عرض الطلب",
  edit_order: "تعديل الطلب",
  tables: "الطاولات",
  employees: "الموظفين",
  invoices: "الفواتير",
  help_desk: "مكتب المساعدة",
  discounts: "الخصومات",
  external_integration: "الربط الخارجي",
  addons: "الإضافات",
  addon_detail: "تفاصيل الإضافة",
  inventory: "المخزون",
  stock: "المخزون المتوفر",
  stock_overview: "نظرة عامة على المخزون",
  stock_adjustment: "تعديل المخزون",
  view_stock_adjustment: "عرض تعديل المخزون",
  stock_transfer: "نقل المخزون",
  view_transfer: "عرض النقل",
  edit_transfer: "تعديل النقل",
  customers: "العملاء",
  customer_details: "تفاصيل العميل",
  sales_invoice: "فاتورة مبيعات A4",
  view_sales_invoice: "عرض فاتورة مبيعات A4",
  tax_configuration: "تهيئة الضريبة",

  // Products
  product_add: "إضافة منتج",
  product_added: "تم إضافة المنتج",
  product_added_successfully: "تم إضافة المنتج بنجاح!",
  product_edit: "تعديل المنتج",
  product_updated: "تم تحديث المنتج",
  product_updated_successfully: "تم تحديث المنتج بنجاح!",
  product_deleted: "تم حذف المنتج",
  product_deleted_successfully: "تم حذف المنتج بنجاح!",
  products_import: "استيراد المنتجات",
  products_import_successfully: "تم استيراد المنتجات بنجاح!",

  // Product Categories
  category_add: "إضافة فئة",
  category_name: "اسم الفئة",
  category_edit: "تعديل الفئة",
  category_name_required: "يرجى إدخال اسم فئة المنتج!",
  category_added: "تم إضافة الفئة",
  category_added_successfully: "تم إضافة الفئة بنجاح!",
  category_updated: "تم تحديث الفئة",
  category_updated_successfully: "تم تحديث الفئة بنجاح!",
  category_deleted: "تم حذف الفئة",
  category_deleted_successfully: "تم حذف الفئة بنجاح!",
  categories_import: "استيراد الفئات",
  categories_import_successfully: "تم استيراد الفئات بنجاح!",

  // Product Units
  unit_add: "إضافة وحدة",
  unit_name: "اسم الوحدة",
  unit_edit: "تعديل الوحدة",
  unit_name_required: "يرجى إدخال اسم وحدة المنتج!",
  unit_added: "تم إضافة الوحدة",
  unit_added_successfully: "تم إضافة الوحدة بنجاح!",
  unit_updated: "تم تحديث الوحدة",
  unit_updated_successfully: "تم تحديث الوحدة بنجاح!",
  unit_deleted: "تم حذف الوحدة",
  unit_deleted_successfully: "تم حذف الوحدة بنجاح!",
  units_import: "استيراد الوحدات",
  units_import_successfully: "تم استيراد الوحدات بنجاح!",

  // Product Options
  option_add: "إضافة خيار",
  option_name: "اسم الخيار",
  option_edit: "تعديل الخيار",
  option_name_required: "يرجى إدخال اسم خيار المنتج!",
  option_added: "تم إضافة الخيار",
  option_added_successfully: "تم إضافة الخيار بنجاح!",
  option_updated: "تم تحديث الخيار",
  option_updated_successfully: "تم تحديث الخيار بنجاح!",
  option_deleted: "تم حذف الخيار",
  option_deleted_successfully: "تم حذف الخيار بنجاح!",
  select_options: "تحديد الخيارات",

  // Branches
  branch_add: "إضافة فرع",
  branch_added: "تم إضافة الفرع",
  branch_added_successfully: "تم إضافة الفرع بنجاح!",
  branch_deleted: "تم حذف الفرع",
  branch_deleted_successfully: "تم حذف الفرع بنجاح!",
  branch_edit: "تعديل الفرع",
  branch_updated: "تم تحديث الفرع",
  branch_updated_successfully: "تم تحديث الفرع بنجاح!",

  // Customers
  customer_add: "إضافة عميل",
  customer_added: "تم إضافة العميل",
  customer_added_successfully: "تم إضافة العميل بنجاح!",
  customer_deleted: "تم حذف العميل",
  customer_deleted_successfully: "تم حذف العميل بنجاح!",
  customer_edit: "تعديل العميل",
  customer_updated: "تم تحديث العميل",
  customer_updated_successfully: "تم تحديث العميل بنجاح!",

  // Orders
  mark_as_in_progress: "تحديد كقيد التنفيذ",
  mark_as_complete: "تحديد كمكتمل",
  add_order: "إضافة طلب",
  cancel_order: "إلغاء الطلب",
  order_added: "تم إضافة الطلب",
  order_added_successfully: "تم إضافة الطلب بنجاح!",
  order_updated: "تم تحديث الطلب",
  order_updated_successfully: "تم تحديث الطلب بنجاح!",

  // Tables
  table_added: "تم إضافة الطاولة",
  table_added_successfully: "تم إضافة الطاولة بنجاح!",
  drive_thru: "طلب سيارات",
  drive_thru_add: "إضافة خدمة طلب السيارات",
  drive_thru_added: "تم إضافة خدمة طلب السيارات",
  drive_thru_added_successfully: "تم إضافة خدمة طلب السيارات بنجاح!",
  entity_updated: "تم تحديث الكيان",
  entity_updated_successfully: "تم تحديث الكيان بنجاح!",
  entity_deleted: "تم حذف الكيان",
  entity_deleted_successfully: "تم حذف الكيان بنجاح!",
  add_table: "إضافة طاولة",
  update_table: "تحديث الطاولة",
  assign_table_to_order: "تعيين طاولة للطلب",
  select_table: "تحديد الطاولة",
  validate_table_required: "حقل الطاولة مطلوب.",

  // Employees
  employee_add: "إضافة موظف",
  employee_added: "تم إضافة الموظف",
  employee_added_successfully: "تم إضافة الموظف بنجاح!",
  employee_edit: "تعديل الموظف",
  employee_updated: "تم تحديث الموظف",
  employee_updated_successfully: "تم تحديث الموظف بنجاح!",
  employee_activate: "تفعيل الموظف",
  employee_activated: "تم تفعيل الموظف",
  employee_activated_successfully: "تم تفعيل الموظف بنجاح!",
  employee_deactivate: "تعطيل الموظف",
  employee_deactivated: "تم تعطيل الموظف",
  employee_deactivated_successfully: "تم تعطيل الموظف بنجاح!",
  employee_deleted: "تم حذف الموظف",
  employee_deleted_successfully: "تم حذف الموظف بنجاح!",

  // Helpdesk
  ticket_add: "إضافة تذكرة",
  ticket_added: "تم إضافة التذكرة",
  ticket_added_successfully: "تم إضافة التذكرة بنجاح!",
  ticket_updated: "تم تحديث التذكرة",
  ticket_updated_successfully: "تم تحديث التذكرة بنجاح!",

  // Discount
  discount_add: "إضافة خصم",
  discount_added: "تم إضافة الخصم",
  discount_added_successfully: "تم إضافة الخصم بنجاح!",
  discount_deleted: "تم حذف الخصم",
  discount_deleted_successfully: "تم حذف الخصم بنجاح!",
  discount_edit: "تعديل الخصم",
  discount_updated: "تم تحديث الخصم",
  discount_updated_successfully: "تم تحديث الخصم بنجاح!",

  // External Integration
  connection_add: "إضافة اتصال",
  connection_update: "تحديث الاتصال",
  connection_added: "تم إضافة الاتصال",
  connection_added_successfully: "تم إضافة الاتصال بنجاح!",
  connection_test: "اختبار الاتصال",
  connection_tested_successfully: "تم اختبار الاتصال بنجاح!",
  connection_tested_failed: "فشل اختبار الاتصال بسبب بيانات اعتماد غير صالحة!",
  connection_save: "حفظ الاتصال",
  connection_saved_successfully: "تم حفظ الاتصال بنجاح!",
  connection_saved_failed: "فشل حفظ الاتصال بسبب بيانات اعتماد غير صالحة!",
  connection_deleted: "تم حذف الاتصال",
  connection_deleted_successfully: "تم حذف الاتصال بنجاح!",

  // Addon
  addon_subscribed: "تم الاشتراك في الإضافة",
  addon_subscribed_successfully: "تم الاشتراك في الإضافة بنجاح!",
  addon_unsubscribed: "تم إلغاء الاشتراك في الإضافة",
  addon_unsubscribed_successfully: "تم إلغاء الاشتراك في الإضافة بنجاح!",
  subscribe_dependent_addons: "يرجى الاشتراك في هذه الإضافات أولاً: {{addons}}",
  unsubscribe_dependency_warning:
    "إذا قمت بإلغاء الاشتراك في إضافة {{addon}}، فقد يتم إلغاء اشتراك هذه الإضافات تلقائيًا أيضًا من حسابك.",
  addon_filter_all_modules: "جميع الوحدات",
  addon_available: "متاح",
  addon_requires: "يتطلب",
  addon_used_by: "مُستخدم من قِبل",
  addon_whats_included: "ما الذي تشمله",
  addon_access: "الوصول",
  addon_daily_price_after_trial: "السعر اليومي بعد الفترة التجريبية",
  addon_available_with_current_setup: "متاح مع إعداداتك الحالية",
  addon_charged_only_when_in_use:
    "يتم الاحتساب فقط عندما تكون هذه الإضافة قيد الاستخدام",
  addon_always_on: "تعمل دائمًا",
  addon_trial_days_label: "أيام تجريبية",
  addon_currently_active: "نشط حاليًا",
  addon_ready_to_activate: "جاهز للتفعيل",
  addon_free_access: "وصول مجاني",
  addon_daily_billed_module: "وحدة تُحسب يوميًا",
  addon_no_trial_period: "لا توجد فترة تجريبية",
  addon_required_addons_count: "إضافة واحدة مطلوبة ({{count}})",
  addon_required_addons_count_other: "{{count}} إضافات مطلوبة",
  addon_no_dependency_required: "لا يتطلب أي تبعيات",
  addon_used_by_addons_count: "مُستخدم من قِبل إضافة واحدة ({{count}})",
  addon_used_by_addons_count_other: "مُستخدم من قِبل {{count}} إضافات",
  addon_standalone_setup: "إعداد مستقل",
  addon_free_trial_days: "فترة تجريبية مجانية لمدة {{days}} يوم",
  addon_always_free: "مجاني دائمًا",
  addon_no_trial_included: "لا تشمل فترة تجريبية",
  addon_per_day: "/ يوم",
  no_addons_found: "لم يتم العثور على إضافات",

  // Invoices
  model: "الموديل",
  imei: "رقم IMEI",
  serial_no: "الرقم التسلسلي",
  due_amount: "المبلغ المستحق",
  installments: "الأقساط",
  warranty_from_to: "الضمان من - إلى",
  warranty_starting_at: "بداية الضمان",
  warranty_ending_at: "نهاية الضمان",
  user_licenses_added: "تم إضافة تراخيص المستخدمين",
  user_licenses_have_been_added_successfully:
    "تم إضافة تراخيص المستخدمين بنجاح!",

  // Topup
  wallet_details: "تفاصيل المحفظة",
  available_credit: "الرصيد المتاح",
  topup: "شحن الرصيد",
  balance_validity: "صلاحية الرصيد",
  topup_request_received: "تم استلام طلب شحن الرصيد",
  topup_request_received_successfully: "تم استلام طلب شحن الرصيد بنجاح!",
  confirmation: "التأكيد",
  check_confirmation_checkbox: "يرجى تحديد خانة اختيار التأكيد!",
  enter_topup_amount: "أدخل مبلغ شحن الرصيد",
  enter_reference_no: "أدخل الرقم المرجعي",
  minimum_topup_amount_required: "الحد الأدنى لمبلغ شحن الرصيد مطلوب",
  your_balance_is_low_please_recharge_minimum:
    "رصيدك منخفض، يرجى إعادة الشحن بالحد الأدنى",

  // Waiter component
  waiter: "النادل",
  add_waiter: "إضافة نادل",
  is_waiter: "نادل",
  update_waiter: "تحديث النادل",
  waiter_updated: "تم تحديث النادل",
  assign_waiter_to_order: "تعيين نادل للطلب",
  select_waiter: "تحديد النادل",
  validate_waiter_required: "حقل النادل مطلوب.",
  waiter_not_available_for_branch: "النادل المحدد غير متاح لهذا الفرع.",
  no_waiter_found_for_branch: "لا يوجد نادل لهذا الفرع.",

  // Job management component
  job_person: "مسؤول المهمة / الفني",
  is_job_person: "مسؤول مهمة",
  select_job_person: "تحديد مسؤول المهمة",
  job_person_updated: "تم تحديث مسؤول المهمة",
  update_job_person: "تحديث مسؤول المهمة",
  validate_job_person_required: "مسؤول المهمة مطلوب.",

  // Inventory component
  adjustment_add: "إضافة تعديل",
  stock_adjustment_done: "تم تعديل المخزون",
  stock_adjustment_done_successfully: "تم تعديل المخزون بنجاح!",
  adjustment_history: "سجل التعديلات",
  direct_transfer: "نقل مباشر",
  request_transfer: "طلب نقل",
  cancel_transfer: "إلغاء النقل",
  accept_transfer: "قبول النقل",
  reject_transfer: "رفض النقل",
  confirm_transfer: "تأكيد النقل",
  transfer_added: "تم إضافة النقل",
  transfer_added_successfully: "تم إضافة النقل بنجاح!",
  transfer_updated: "تم تحديث النقل",
  transfer_updated_successfully: "تم تحديث النقل بنجاح!",

  // Sales Invoice
  invoice_add: "إضافة فاتورة",
  invoice_added: "تم إضافة الفاتورة",
  invoice_added_successfully: "تم إضافة الفاتورة بنجاح!",
  invoice_updated: "تم تحديث الفاتورة",
  invoice_updated_successfully: "تم تحديث الفاتورة بنجاح!",
  invoice_edit: "تعديل الفاتورة",
  invoice_deleted: "تم حذف الفاتورة",
  invoice_deleted_successfully: "تم حذف الفاتورة بنجاح!",
  save_as_draft: "حفظ كمسودة",
  issue_invoice: "إصدار الفاتورة",
  register_payment: "تسجيل الدفع",

  // Tax
  tax: "الضريبة",
  tax_add: "إضافة ضريبة",
  tax_added: "تم إضافة الضريبة",
  tax_added_successfully: "تم إضافة الضريبة بنجاح!",
  tax_updated: "تم تحديث الضريبة",
  tax_updated_successfully: "تم تحديث الضريبة بنجاح!",
  tax_edit: "تعديل الضريبة",
  tax_deleted: "تم حذف الضريبة",
  tax_deleted_successfully: "تم حذف الضريبة بنجاح!",
  select_taxes: "تحديد الضرائب",

  // Ticketing
  tickets: "التذاكر",
  is_ticket: "تذكرة",
  issue_ticket: "إصدار تذكرة",
  print_ticket: "طباعة التذكرة",
  ticket_issue_failed: "فشل إصدار التذكرة. يرجى المحاولة مرة أخرى.",
  no_unissued_ticket_found: "لا توجد تذكرة غير مصدرة لهذه المعاملة.",
  person_one: "شخص",
  person_other: "أشخاص",
  not_scanned: "لم تُمسح ضوئيًا",
  partially_scanned: "ممسوحة جزئيًا",
  fully_scanned: "ممسوحة بالكامل",

  // Table Columns
  product: "المنتج",
  category: "الفئة",
  unit: "الوحدة",
  option: "الخيار",
  barcode: "الباركود",
  amount: "المبلغ",
  quantity: "الكمية",
  status: "الحالة",
  created_at: "أنشئ في",
  created_by: "أنشئ بواسطة",
  paid_at: "دُفع في",
  subtotal: "المجموع الفرعي",
  sold_quantities: "الكميات المباعة",
  gross_sales: "إجمالي المبيعات",
  refund_quantities: "الكميات المرتجعة",
  gross_refund: "إجمالي المرتجعات",
  start_date: "تاريخ البدء",
  end_date: "تاريخ الانتهاء",
  date: "التاريخ",
  subscription_plan: "خطة الاشتراك",
  transaction_id: "رقم العملية",
  discount_percentage: "نسبة الخصم",
  invoice_id: "رقم الفاتورة",
  subscription: "الاشتراك",
  license: "الترخيص",
  total_amount_charged: "إجمالي المبلغ المحسوب",
  items: "العناصر",
  user: "المستخدم",
  payment: "الدفع",
  new: "تذاكر جديدة",
  inprogress: "تذاكر قيد التنفيذ",
  done: "تذاكر منتهية",
  closed: "تذاكر مغلقة",
  allow_refund: "السماح بالاسترجاع",
  allow_add_products: "السماح بإضافة منتجات",
  allow_edit_products: "السماح بتعديل المنتجات",
  source: "المصدر",
  pending_orders: "طلبات معلقة",
  inprogress_orders: "طلبات قيد التنفيذ",
  completed_orders: "طلبات مكتملة",
  cancelled_orders: "طلبات ملغاة",
  branch_from: "من فرع",
  branch_to: "إلى فرع",
  draft_invoices: "فواتير مسودة",
  open_invoices: "فواتير مفتوحة",
  partially_paid_invoices: "فواتير مدفوعة جزئيًا",
  paid_invoices: "فواتير مدفوعة",
  balance: "الرصيد",
  due_date: "تاريخ الاستحقاق",
  low_stock: "مخزون منخفض",

  // Reports
  net_sales: "صافي المبيعات",
  total_sales: "إجمالي المبيعات",
  refunds: "المرتجعات",
  sales: "المبيعات",
  payments: "المدفوعات",
  net_total: "الصافي الإجمالي",
  total_refunds: "إجمالي المرتجعات",
  total: "الإجمالي",
  vat: "ضريبة القيمة المضافة",
  taxes_on_sale: "الضرائب على المبيعات",
  total_taxes_on_sale: "إجمالي الضرائب على المبيعات",
  quarterly_tax: "الضريبة على المبيعات الربع سنوية",
  payment_types: "أنواع الدفع",
  quarterly_sales: "المبيعات الربع سنوية",
  sales_overview: "نظرة عامة على المبيعات",

  // Warnings
  warning_remove: "هل أنت متأكد من إزالة هذا الكيان؟",
  warning_delete: "هل أنت متأكد من حذف هذا الكيان؟",
  warning_logout: "هل أنت متأكد من تسجيل الخروج؟",
  warning_empty_basket: "هل أنت متأكد من رغبتك في حذف هذه المنتجات من السلة؟",
  warning_remove_product: "هل أنت متأكد من رغبتك في حذف هذا المنتج من السلة؟",
  warning_delete_stock_product:
    "يرجى التأكد من أنه في حال حذف هذا المنتج، فسيتم حذف المخزون تلقائيًا.",
  warning_unsubscribe_addon:
    "إذا قمت بإلغاء الاشتراك في الإضافة، فسيتم إزالة البيانات من الخادم بعد 3 أيام",

  // Status
  status_paid: "مدفوع",
  status_refunded: "مسترجع",

  // Miscellaneous
  yes: "نعم",
  no: "لا",
  logout: "تسجيل الخروج",
  logging_out: "جاري تسجيل الخروج...",
  cancel: "إلغاء",
  add: "إضافة",
  edit: "تعديل",
  update: "تحديث",
  submit: "إرسال",
  confirm: "تأكيد",
  search: "بحث",
  upload: "تحميل",
  back: "رجوع",
  order_id: "رقم الطلب",
  order_details: "تفاصيل الطلب",
  issued_at: "أصدر في",
  date_range: "الفترة الزمنية",
  delete_entity: "حذف الكيان",
  something_went_wrong: "حدث خطأ ما",
  refund: "استرجاع",
  user_can_edit_price_on_pos: "يمكن للمستخدم تعديل السعر في نقطة البيع",
  user_can_apply_discount: "يمكن للمستخدم تطبيق الخصم",
  user_see_transactions: "يمكن للمستخدم رؤية العمليات",
  user_can_refund_transaction: "يمكن للمستخدم استرجاع العملية",
  user_can_add_edit_products: "يمكن للمستخدم إضافة وتعديل المنتجات",
  user_can_request_stock_transfer: "يمكن للمستخدم طلب نقل المخزون",
  user_can_approve_stock_transfer: "يمكن للمستخدم الموافقة على نقل المخزون",
  user_allowed_stock_adjustment: "يُسمح للمستخدم بتعديل المخزون",
  user_can_add_edit_customers: "يمكن للمستخدم إضافة وتعديل العملاء",
  user_can_view_customers: "يمكن للمستخدم عرض العملاء",
  user_can_add_pay_sales_invoices: "يمكن للمستخدم إضافة ودفع فاتورة مبيعات A4",
  user_can_view_sales_invoices: "يمكن للمستخدم عرض فاتورة مبيعات A4",
  user_can_scan_view_ticket: "يمكن للمستخدم مسح وعرض التذكرة",
  user_can_manage_zatca:
    "يمكن للمستخدم إدارة الفوترة الإلكترونية لهيئة الزكاة والضريبة والجمارك (ZATCA)",
  is_machine_user: "مستخدم جهاز / آلة",
  proceed: "متابعة",
  checkout: "الدفع والخروج",
  payment_type: "نوع الدفع",
  cash_collected: "النقد المستلم",
  reference_no: "الرقم المرجعي",
  collected_by_cash: "المستلم نقدًا",
  collected_by_card: "المستلم بالبطاقة",
  charged_amount: "المبلغ المطلوب",
  ask_more_cash: "يرجى طلب المزيد من النقد قبل المتابعة!",
  return_back_amount: "المبلغ المتبقي / المرتجع",
  collect_more_cash: "تحصيل المزيد من النقد",
  print: "طباعة",
  print_bill: "طباعة الفاتورة",
  print_invoice: "طباعة الفاتورة الضريبية",
  declaration: "الإقرار",
  declaration_text:
    "أقر بموجب هذا بأن المعلومات المقدمة في هذا النموذج دقيقة وكاملة. وأؤكد أنه في حال تبين أن أي معلومات غير صحيحة و/أو غير كاملة تؤدي إلى انتهاك اللوائح، فقد يتم اتخاذ إجراءات قانونية، وأقبل بأنني الطرف المسؤول عن أي وجميع الرسوم والغرامات والمخالفات.",
  stc_pay_declaration_text:
    "أقر بموجب هذا بأن الرقم المرجعي الخاص بـ STC Pay المقدم في هذا النموذج دقيق وكامل. سيظهر رصيدك في لوحة التحكم خلال يوم عمل واحد.",
  upgrade: "ترقية",
  upgrade_subscription: "ترقية الاشتراك",
  payment_successful: "تم الدفع بنجاح!",
  your_payment_successfully: "عملية الدفع الخاصة بك تمت بنجاح.",
  payment_failed: "فشلت عملية الدفع!",
  try_again_payment_failed: "فشلت عملية الدفع. يرجى المحاولة مرة أخرى.",
  all: "الكل",
  cart_empty: "سلتك فارغة.",
  total_amount: "المبلغ الإجمالي",
  licenses: "الترخيص / التراخيص",
  purchase: "شراء",
  credit_card: "بطاقة ائتمان",
  stc_pay: "STC Pay",
  mada: "مدى (MADA)",
  cash: "نقدًا",
  card: "بطاقة",
  bank: "بنك",
  multi_payment: "دفع متعدد",
  plz_fill_details: "يرجى ملء التفاصيل أدناه للمتابعة",
  billing_details: "تفاصيل الفوترة",
  business_address_details: "تفاصيل عنوان النشاط التجاري",
  discount: "خصم",
  select_a_discount: "تحديد خصم",
  unpaid_invoice: "فاتورة غير مدفوعة!",
  pay_your_invoice: "يرجى دفع فاتورتك غير المدفوعة",
  show_invoices: "عرض الفواتير",
  what_type_of_refund: "ما هو نوع الاسترجاع الذي ترغب في القيام به؟",
  full: "كامل",
  partial: "جزئي",
  refund_amount: "مبلغ الاسترجاع",
  zatca_refund_reason_required: "سبب الاسترجاع الخاص بـ ZATCA مطلوب",
  zatca_refund_reason_helper:
    "تم إنشاء هذه العملية كفاتورة ZATCA. اختر السبب الذي سيتم إرساله مع إشعار الاسترجاع الدائن.",
  select_zatca_refund_reason: "اختر سبب الاسترجاع",
  zatca_refund_reason_cancellation_suspension: "الإلغاء / التعليق",
  zatca_refund_reason_goods_services_refund: "استرجاع السلع / الخدمات",
  zatca_refund_reason_price_reduction_discount: "تخفيض السعر / الخصم",
  zatca_refund_reason_invoice_errors: "أخطاء الفاتورة",
  zatca_refund_reason_change_in_information: "تغيير في المعلومات",
  qty: "الكمية",
  additional_info: "معلومات إضافية",
  users: "المستخدمين",
  action: "الإجراء",
  pay_now: "ادفع الآن",
  view_invoice: "عرض الفاتورة",
  one_time_payment: "دفع لمرة واحدة",
  complete: "مكتمل",
  incomplete: "غير مكتمل",
  max_upload_size_10mb_warning: "الحد الأقصى لحجم التحميل: 10 ميجابايت",
  max_upload_size_2mb_warning: "الحد الأقصى لحجم التحميل: 2 ميجابايت",
  account_under_verification: "حسابك قيد التحقق!",
  notified_once_verified:
    "شكرًا لك على التسجيل، سيتم إخطارك على رقم هاتفك المحمول بمجرد التحقق من حسابك.",
  account_blocked: "حسابك محظور!",
  kindly_contact_at: "يرجى الاتصال بنا على contact@anypos.ai",
  is_vat_exempt: "ليس لدي شهادة ضريبة القيمة المضافة",
  vat_exempt_latter_sample: "نموذج خطاب الإعفاء الضريبي",
  vat_exempt_latter: "خطاب الإعفاء الضريبي",
  connection: "الاتصال",
  connected: "متصل",
  disconnected: "غير متصل",
  download_report: "تحميل التقرير",
  download_sales_report: "تحميل تقرير المبيعات",
  download_payments_report: "تحميل تقرير المدفوعات",
  download_template: "تحميل النموذج",
  skip: "تخطي",
  fill_the_details: "املأ التفاصيل",
  kindly_complete_the_store_details_within: "يرجى إكمال تفاصيل المتجر خلال",
  days_otherwise_your_account_will_be_blocked: "أيام وإلا سيتم حظر حسابك.",
  unlimited: "غير محدود",
  per_user: "لكل مستخدم",
  payment_modal: "نافذة الدفع",
  select_payment_method: "اختر طريقة الدفع",
  service_name: "اسم الخدمة",
  subscriptions_history: "سجل الاشتراكات",
  spending_history: "سجل الإنفاق",
  trial_days: "الأيام التجريبية",
  paid: "مدفوع",
  unpaid: "غير مدفوع",
  qr: "رمز QR",
  dining_table: "طاولة طعام",
  note: "ملاحظة",
  clear: "مسح",
  selected_item: "العنصر المختار",
  pending: "معلق",
  completed: "مكتمل",
  cancelled: "ملغى",
  refunded: "تم الاسترداد",
  recharge_request: "طلب إعادة شحن",
  rejected: "مرفوض",
  available_stock: "المخزون المتاح",
  requested_stock: "المخزون المطلوب",
  current_stock: "المخزون الحالي",
  your_branch: "فرعك",
  approved_quantity: "الكمية المعتمدة",
  requested_quantity: "الكمية المطلوبة",
  insufficient_quantity: "كمية غير كافية",
  out_of_stock: "نفذ من المخزون",
  product_already_selected: "المنتج مختار بالفعل",
  basket: "السلة",
  search_product_name_here: "ابحث عن اسم المنتج هنا",
  welcome_to: "مرحبًا بكم في",
  call_to_waiter: "نداء النادل",
  order: "الطلب",
  select_language: "اختر اللغة",
  place_order: "تقديم الطلب",
  basket_empty: "سلتك فارغة!",
  menu: "القائمة",
  order_placed_successfully: "تم تقديم طلبك بنجاح!",
  hi: "مرحبًا",
  welcome_anypos: "مرحبًا بكم في AnyPOS!",
  place_new_order: "تقديم طلب جديد",
  your_order: "طلبك",
  expired: "منتهي الصلاحية",
  is_expired: "منتهي الصلاحية",
  late_payment: "دفعة متأخرة",
  is_late_payment: "دفعة متأخرة",
  addon_selected: "الإضافة المختارة",
  all_prices_daily_basis: "جميع الأسعار على أساس يومي.",
  we_only_charge_use_addon: "سيتم احتساب الرسوم فقط عند استخدام الإضافة.",
  free: "مجاني",
  free_trial: "مجاني في الفترة التجريبية",
  need_addons: "هل تحتاج إلى إضافات؟",
  value: "القيمة",
  taxes: "الضرائب",
  total_without_tax: "الإجمالي بدون الضريبة",
  price_including_tax: "السعر شامل الضريبة",
  total_taxes: "إجمالي الضرائب",
  total_with_tax: "الإجمالي مع الضريبة",
  branch_selling_products: "المنتجات المباعة في الفرع",
  filters: "التصنيفات / الفلاتر",
  sales_insight: "رؤى المبيعات",
  disabled: "معطل",
  after_trials: "بعد الفترة التجريبية لكل يوم",
  cannot_select_table_management_while_job_management_is_active:
    "لا يمكن تحديد إدارة الطاولات أثناء تفعيل إدارة المهام.",
  cannot_select_job_management_while_waiter_management_or_table_management_is_active:
    "لا يمكن تحديد إدارة المهام أثناء تفعيل إدارة النادل أو إدارة الطاولات.",
  cannot_select_waiter_management_while_job_management_is_active:
    "لا يمكن تحديد إدارة النادل أثناء تفعيل إدارة المهام.",
  dependent_addons: "الإضافات التابعة",
  successfully_added: "تمت الإضافة بنجاح",
  generate_ai_image_for_one_product: "توليد صورة بالذكاء الاصطناعي لمنتج واحد",
  generate_ai_images_for_products:
    "توليد صور بالذكاء الاصطناعي لعدد {{count}} من المنتجات",
  generating_images_with_ai:
    "جارٍ توليد صور بالذكاء الاصطناعي لعدد {{count}} من المنتجات",
  image_generated: "تم توليد الصورة",
  image_generated_successfully: "تم توليد الصورة بنجاح!",
  images_generated: "تم توليد الصور",
  images_generated_successfully: "تم توليد صور {{count}} من المنتجات بنجاح!",
  images_generation_started: "بدأ توليد الصور بالذكاء الاصطناعي",
  images_generation_started_desc:
    "جارٍ توليد صور {{count}} من المنتجات في الخلفية.",
  images_generation_failed: "فشل توليد الصور",
  images_generation_completed_with_errors:
    "تم توليد {{completed}} صورة، وفشل {{failed}}.",
  products_already_have_images: "المنتجات المحددة لديها صور بالفعل.",
  image_generation_live_updates_unavailable:
    "التحديثات الفورية غير متاحة؛ ستظهر الصور المولدة عند تحميل قائمة المنتجات في المرة القادمة.",
  Showing_transactions_from_all_branches: "عرض العمليات من جميع الفروع",
  Showing_transactions_from_my_branch: "عرض العمليات من فرعي الحالي",
  all_data: "جميع البيانات",
  branch_data: "بيانات الفرع",
  Showing_orders_from_all_branches: "عرض الطلبات من جميع الفروع",
  Showing_orders_from_my_branch: "عرض الطلبات من فرعي الحالي",
  total_stock: "إجمالي المخزون",
  branch_stock: "مخزون الفرع",
  view_all: "عرض الكل",
  photo: "الصورة الشخصية",
  nationality: "الجنسية",
  id_number: "رقم الهوية",
  products_by_category: "المنتجات حسب الفئة",
  view_details: "عرض التفاصيل",
  how_would_you_like_to_order: "كيف تود الطلب؟",
  order_with_ai: "الطلب بالذكاء الاصطناعي",
  order_yourself: "اطلب بنفسك",
  no_menu_data_found: "لم يتم العثور على بيانات القائمة",
  please_scan_valid_qr_code_or_try_again_later:
    "يرجى مسح رمز QR صالح أو المحاولة مرة أخرى لاحقًا.",
  order_mode: "وضع الطلب",
  change_mode: "تغيير الوضع",
  powered_by_anypos: "مشغل بواسطة AnyPOS",
  is_calories: "عرض السعرات الحرارية",
  calories_info: "معلومات السعرات الحرارية",

  calories: "السعرات الحرارية",
  configuration: "التهيئة / الإعدادات",
  trial_addons_expiring_today: "تنتهي الفترة التجريبية للإضافات اليوم",
  trial_addons_message:
    "هذه الإضافات قيد التجربة حاليًا وستنتهي صلاحيتها اليوم. إذا اخترت الاحتفاظ بها، فستبدأ رسوم الإضافات من الغد وسيتم خصمها من رصيدك. هل تريد الاحتفاظ بها أم إلغاء الاشتراك؟",
  trial_ends_today: "تنتهي الفترة التجريبية اليوم",
  unsubscribe_all_addons: "إلغاء اشتراك الكل",
  keep_addons: "الاحتفاظ بالإضافات",
  needs: "يتطلب",
  affects: "يؤثر على",
  addon_needs_title: "هذه الإضافة تحتاج إلى إضافات أخرى",
  addon_needs_description:
    "لإبقاء {{addon}} نشطة، يجب أيضًا تمكين الإضافات التالية:",
  addon_affects_title: "إزالة هذه الإضافة ستؤثر على ميزات أخرى",
  addon_affects_description:
    "إذا قمت بتعطيل {{addon}}، فسيتم تعطيل الإضافات التالية أيضًا لأنها تعتمد عليها:",
  addons_updated: "تم تحديث الإضافات",
  addons_updated_successfully: "تم تحديث تفضيلات الإضافات الخاصة بك بنجاح!",
  also_disabled_depends_on: "سيتم تعطيلها أيضًا لأنها تعتمد على",
  addon_depends_on_message:
    "تعتمد إضافة {{addon}} على {{addons}}. يرجى تحديد {{target}} أولاً.",
  addon_remove_affects_message:
    "تعتمد {{addons}} {{verb}} على {{addon}}. وسيتم إزالة {{pronoun}} أيضًا.",

  depend: "تعتمد",
  depends: "تعتمد",
  it: "هو/هي",
  these: "هذه",
  that: "ذلك",
  those: "تلك",
  generating_image_with_ai: "يرجى الانتظار، جاري إنشاء أفضل صورة لك",
  please_wait_a_moment: "يرجى الانتظار لبعض الوقت",
  addon_needs_short: "تحتاج إضافة {{addon}} إلى هذه الإضافات لتعمل.",
  addon_affects_short:
    "إذا قمت بتعطيل {{addon}}، فقد يتم تعطيل هذه الإضافات أيضًا.",

  customer_display: "شاشة العميل",
  product_expired: "منتج منتهي الصلاحية",
  dine_in: "تناول في المطعم",
  takeaway: "سفري / خارجي",

  kitchen_status: "حالة المطبخ",
  awaiting: "في الانتظار",
  preparing: "جاري التحضير",
  cooked: "جاهز / مطهو",
  order_type: "نوع الطلب",

  display_screens: "شاشات العرض",
  last_seen: "آخر ظهور",
  bound_by: "مرتبط بواسطة",
  unbind_this_device: "إلغاء ربط هذا الجهاز؟",
  unbind_pos_and_cds: "إلغاء ربط جهاز نقطة البيع وشاشة العميل المرتبطة؟",
  device_added: "تم إضافة الجهاز",
  device_added_successfully: "تم إضافة الجهاز بنجاح!",
  device_unbind: "إلغاء ربط الجهاز",
  device_unbind_successfully: "تم إلغاء ربط الجهاز بنجاح!",
  add_kitchen_screen: "إضافة شاشة مطبخ",
  add_customer_screen: "إضافة شاشة عميل",
  generate_code: "توليد الرمز",

  customer_display_screen: "شاشة عرض العميل",
  register_pos_terminal: "تسجيل جهاز نقطة البيع",
  pos_terminal: "جهاز نقطة البيع",
  expires_in: "تنتهي الصلاحية خلال",
  register_pos_terminal_first: "سجل جهاز نقطة البيع أولاً",
  enter_pairing_code_instruction:
    "أدخل رمز الاقتران هذا على شاشة العرض. تنتهي صلاحيته خلال ",
  pairing_code_expired_message:
    "انتهت صلاحية رمز الاقتران هذا. يرجى توليد رمز جديد.",
  linked_pos_uid: "معرف نقطة البيع المرتبط (UID)",
  not_registered: "غير مسجل",

  kitchen_display_screens: "شاشات عرض المطبخ",
  kitchen_display_screen: "شاشة عرض المطبخ",

  pos_terminal_already_registered:
    "جهاز نقطة البيع مسجل بالفعل. يرجى إلغاء ربطه أولاً.",
  open_screen_device_url_instruction:
    "افتح هذا الرابط على جهاز الشاشة، ثم أدخل رمز التحقق OTP:",

  takeaway_cancel_refund_warning:
    "إذا قمت بإلغاء هذا الطلب الخارجي، فسيتم استرداد المبلغ تلقائيًا.",

  transaction_refunded: "تم استرجاع العملية",
  transaction_refunded_successfully: "تم استرجاع العملية بنجاح!",
  cancel_order_before_refund:
    "لاسترجاع هذا الطلب، تحتاج إلى إلغاء الطلب أولاً.",
  ok: "موافق",

  pricing_badge:
    "فترة تجريبية مجانية لمدة {{days}} يومًا على وحدات مختارة · لا تتطلب بطاقة ائتمان",
  simple_pricing: "أسعار بسيطة.",
  pay_only_for_what_you_use: "ادفع فقط مقابل ما تستخدمه.",
  pricing_hero_desc:
    "ابدأ مجانًا. اشحن الرصيد عندما تكون مستعدًا. ادفع فقط عن الأيام التي تفتح فيها — لا يوجد اشتراك ثابت يستنزف حسابك.",
  pricing_free_trial_included: "تشمل فترة تجريبية مجانية لمدة {{days}} يومًا",
  pricing_trial_desc: "{{addons}} مجانية لمدة {{days}} يومًا. بدون أي التزام.",

  how_many_users: "كم عدد المستخدمين؟",
  pos_users: "مستخدمو نقاط البيع",
  pricing_users_desc:
    "كل مستخدم = {{amount}} ريال سعودي لكل يوم نشط · يتم الاحتساب فقط عند تسجيل الدخول",
  per_day: "لكل يوم",

  included_in_every_plan: "مشمول في كل خطة",
  point_of_sale: "نقطة البيع",
  zatca_invoicing: "الفوترة الإلكترونية (ZATCA)",
  customer_database: "قاعدة بيانات العملاء",
  multi_branch: "فروع متعددة",
  products_catalogue: "كتالوج المنتجات",
  sales_reports: "تقارير المبيعات",
  tap_to_pay: "الدفع عبر الجوال (Tap to Pay)",
  business_types: "أنواع الأنشطة التجارية",

  choose_your_modules: "اختر الوحدات الخاصة بك",
  included_in_this_group: "مشمول في هذه المجموعة",
  pricing_no_extra_dependency: "لا توجد تبعيات إضافية",

  your_plan_summary: "ملخص خطتك",
  daily_total: "الإجمالي اليومي",
  daily_subscription_plan_unavailable:
    "خطة الاشتراك اليومية غير متاحة حاليًا. يرجى المحاولة مرة أخرى لاحقًا.",
  pricing_after_trial_note:
    "بعد الفترة التجريبية لمدة {{days}} يومًا · في الأيام النشطة فقط",
  included: "مشمول",
  start_free_trial: "بدء الفترة التجريبية المجانية",
  pricing_cta_line_1:
    "فترة تجريبية لمدة {{days}} يومًا على الوحدات المدفوعة · لا تتطلب بطاقة ائتمان",
  pricing_cta_line_2:
    "ادفع {{amount}} ريال سعودي/يوم + ضريبة القيمة المضافة بعد الفترة التجريبية",

  complete_signup_details:
    "أكمل تفاصيل نشاطك التجاري لتفعيل فترتك التجريبية المجانية.",
  otp_verify_subtitle: "أدخل الرمز المرسل إلى رقم هاتفك المحمول للمتابعة.",

  pricing_group_fnb_title: "مقهى، مطعم وأنشطة الأغذية",
  pricing_group_fnb_desc:
    "إدارة الطلبات والطاولات والمطبخ والنادل لأنشطة الأغذية والمطاعم",

  pricing_group_job_title: "الصيانة، غسيل السيارات والتوصيل",
  pricing_group_job_desc: "تتبع المهام والوظائف لفرق الخدمة الميدانية",

  pricing_group_stock_title: "إدارة المخزون",
  pricing_group_stock_desc:
    "تتبع المخزون في الوقت الفعلي، تنبيهات انخفاض المخزون، وكتالوج المنتجات",

  pricing_group_ticket_title: "حجز وتوليد التذاكر",
  pricing_group_ticket_desc:
    "بيع ومسح التذاكر للفعاليات، المواقف، العروض، وأماكن الجذب السياحي",

  popup_pos_eyebrow: "مستخدمو نقاط البيع — الميزات المشمولة",
  popup_pos_title: "يعمل لأي نشاط تجاري يقوم بالبيع",
  popup_pos_desc:
    "تتضمن خطة نقاط البيع الأساسية كل ما تحتاجه لإدارة المبيعات اليومية، وإصدار فواتير متوافقة مع هيئة الزكاة والضريبة والجمارك (ZATCA)، وإدارة العملاء — دون الحاجة إلى وحدات إضافية.",

  popup_fnb_title: "مصمم لعمليات الأغذية والمشروبات",
  popup_fnb_desc:
    "تضيف هذه الوحدة إدارة الطاولات، وتعيين النادل، والطلب عبر رمز QR، وشاشة عرض المطبخ، وشاشة عرض العميل — وهي جميع الأدوات التي يحتاجها نشاط الأغذية ليعمل بسلاسة.",

  popup_job_title: "للخدمات الميدانية والأنشطة القائمة على المهام",
  popup_job_desc:
    "تتيح لك هذه الوحدة تعيين المهام للفنيين، وتتبع تقدم العمل في الوقت الفعلي، وإدارة زيارات خدمة العملاء — بدءًا من الحجز الأول وحتى الإكمال.",

  popup_stock_title: "لأي نشاط تجاري لديه مخزون مادي",
  popup_stock_desc:
    "تتبع ما لديك، واحصل على تننبيهات عندما ينخفض المخزون، وادير المنتجات عبر فروع متعددة — يعمل مع أي نوع من الأنشطة التجارية.",

  industry_gold_jewelry: "محلات الذهب والمجوهرات",
  industry_clothing_fashion: "الملابس والأزياء",
  industry_pharmacies: "الصيدليات",
  industry_grocery_supermarkets: "البقالة والسوبرماركت",
  industry_cosmetics_beauty: "مستحضرات التجميل والعناية بالجمال",
  industry_electronics_phones: "الإلكترونيات والهواتف",
  industry_furniture_home: "الأثاث والمنزل",
  industry_laundry_dry_clean: "المغاسل والتنظيف الجاف",
  industry_salons_barbershops: "الصالونات ومحلات الحلاقة",
  industry_any_retail_business: "أي نشاط تجاري للتجزئة",

  industry_cafes_coffee_shops: "المقاهي والكافيهات",
  industry_dine_in_restaurants: "مطاعم الخدمة داخل الصالة",
  industry_fast_food_qsr: "الوجبات السريعة والمطاعم ذات الخدمة السريعة",
  industry_food_courts: "صالات الطعام",
  industry_bakeries_desserts: "المخابز والحلويات",
  industry_healthy_food_outlets: "منافذ الأطعمة الصحية",
  industry_drive_through: "طلب السيارات (Drive-Through)",
  industry_cloud_kitchens: "المطابخ السحابية",

  industry_ac_hvac_repair: "إصلاح التكييف والتبريد",
  industry_car_wash_detailing: "غسيل وتلميع السيارات",
  industry_electrical_services: "الخدمات الكهربائية",
  industry_plumbing_maintenance: "السباكة والصيانة",
  industry_cleaning_services: "خدمات التنظيف",
  industry_delivery_logistics: "التوصيل والخدمات اللوجستية",
  industry_moving_services: "خدمات نقل الأثاث",
  industry_home_healthcare: "الرعاية الصحية المنزلية",

  industry_gold_jewelry_short: "الذهب والمجوهرات",
  industry_fashion_clothing: "الأزياء والملابس",
  industry_grocery_stores: "محلات البقالة",
  industry_restaurants: "المطاعم",
  industry_wholesale_distribution: "الجملة والتوزيع",
  industry_hardware_tools: "المعدات والأدوات",
  industry_beauty_cosmetics: "الجمال ومستحضرات التجميل",

  validation_error: "خطأ في التحقق",
  otp_validation_failed_try_again:
    "فشل التحقق من رمز التحقق (OTP)، حاول مرة أخرى.",

  // ZATCA — Seller Address (Saudi National Address)
  zatca_settings: "إعدادات ZATCA — عنوان البائع",
  zatca_settings_subtitle:
    "مطلوب من هيئة الزكاة والضريبة والجمارك على كل فاتورة إلكترونية. يُستخدم أثناء تسجيل الجهاز.",
  zatca_settings_helper_title: "مطلوب للفوترة الإلكترونية",
  zatca_settings_helper: "يجب ملء الحقول كلها قبل تفعيل ZATCA لفرع ما.",
  business_name_arabic: "اسم المنشأة باللغة العربية",
  street_name: "اسم الشارع",
  plot_identification: "رقم قطعة الأرض",
  district: "الحي",
  address_sa_help:
    "لا تعرف هذه التفاصيل؟ ابحث عنها في العنوان الوطني address.sa ←",

  company_data_validation_failed:
    "فشل التحقق من بيانات المنشأة. يرجى إكمال جميع حقول عنوان بائع ZATCA قبل المتابعة.",

  // Store Configuration — section group titles & helper copy
  business_information: "معلومات المنشأة",
  business_information_helper:
    "التفاصيل الأساسية حول منشأتك — تظهر على الإيصالات والتقارير.",
  tax_compliance: "الامتثال والضريبة",
  tax_compliance_helper: "أرقام التسجيل والشهادات المطلوبة للامتثال الضريبي.",
  business_address_details_helper:
    "العنوان الرسمي للنشاط التجاري المستخدم في الفواتير ومستندات الأعمال.",
  kindly_check_declaration: "يرجى التحقق من الإقرار للتأكيد قبل المتابعة.",

  // Logo management
  remove: "إزالة",
  remove_logo: "إزالة الشعار",
  confirm_remove_logo:
    "هل أنت متأكد من رغبتك في إزالة شعار منشأتك؟ سيتم حذف الشعار المحفوظ.",
  logo_removed: "تم إزالة الشعار.",

  // ZATCA opt-in toggle
  zatca_enable_question:
    "هل تريد ربط الفوترة الإلكترونية للمرحلة الثانية من ZATCA؟",
  zatca_enable_helper:
    "مطلوب للأنشطة التجارية التي تصدر فواتير ضريبية في المملكة العربية السعودية.",
  zatca_locked_helper:
    "تم تقديم تفاصيل عنوان البائع لـ ZATCA ولا يمكن تعديلها بعد الآن. اتصل بالدعم إذا كنت بحاجة إلى إجراء تغييرات.",
  zatca_not_configured: "الفوترة الإلكترونية لـ ZATCA غير مفعّلة لهذا المتجر.",
  zatca_not_configured_helper:
    "افتح نموذج التعديل لتشغيل المرحلة الثانية من ZATCA وإدخال تفاصيل عنوان البائع عندما تكون مستعدًا.",

  // Page chrome
  zatca_onboarding: "تهيئة الامتثال لـ ZATCA",
  zatca_invoices: "فواتير ZATCA",
  zatca_invoice_issues: "مشاكل فواتير زاتكا",
  zatca_invoice_issues_failed: "فشل تحميل مشاكل فواتير زاتكا",
  issue_type: "نوع المشكلة",
  issue_summary: "ملخص المشكلة",
  search_invoice_issues_placeholder:
    "ابحث برقم UUID للفاتورة أو رقم السجل التجاري أو نص التحذير أو الخطأ",
  onboard_zatca: "ربط وتهيئة ZATCA",
  enable_zatca: "تفعيل ZATCA",

  // Table columns / labels
  device_name: "اسم الجهاز",
  environment: "البيئة",
  csid_expiry: "انتهاء صلاحية شهادة CSID",
  last_icv: "آخر عداد للفواتير (ICV)",

  missing_fields: "حقول مفقودة",

  // KYC pre-flight
  zatca_kyc_complete_title: "حقول عنوان اعرف عميلك (KYC) مكتملة",
  zatca_kyc_incomplete_title: "أكمل عنوان ZATCA أولاً",
  zatca_kyc_incomplete_helper:
    "بعض حقول عنوان البائع المطلوبة من ZATCA مفقودة من ملف تعريف متجرك. افتح تهيئة المتجر لتعبئتها.",
  complete_zatca_address_fields: "إكمال حقول عنوان ZATCA",

  env_sandbox: "البيئة التجريبية (Sandbox)",
  env_simulation: "البيئة المحاكية (Simulation)",
  env_production: "البيئة الحية / الإنتاجية (Production)",

  get_your_otp: "احصل على رمز التحقق (OTP)",
  zatca_otp_instructions_helper:
    "افتح fatoora.zatca.gov.sa ← تهيئة الفوترة الإلكترونية ← إنشاء رمز التحقق. صالح لمدة ساعة واحدة.",
  copy_portal_url: "نسخ رابط البوابة",
  zatca_portal_url_copied: "تم نسخ رابط البوابة إلى الحافظة.",
  otp_6_digits: "رمز التحقق OTP (6 أرقام)",

  already_onboarded: "تمت تهيئته بالفعل لهذه البيئة",
  csid_expired: "انتهت صلاحية شهادة CSID",
  failed: "فشل",
  device_onboarded: "تم تهيئة الجهاز بنجاح",
  zatca_onboard_success_helper:
    "ZATCA نشط الآن لـ {{branch}} في بيئة {{environment}}.",
  zatca_onboard_failed_helper:
    "لم نتمكن من تهيئة هذا الجهاز. يرجى التحقق من رمز OTP والمحاولة مرة أخرى.",
  permission_required_title: "الإذن مطلوب",
  zatca_permission_required_helper:
    "المستخدمون الذين يملكون إذن ZATCA فقط يمكنهم تهيئة الأجهزة. اطلب من صاحب المنشأة منحك الإذن في شاشة صلاحيات الموظفين.",
  zatca_taking_longer_title: "استجابة ZATCA تستغرق وقتًا أطول من المعتاد",
  zatca_taking_longer_helper:
    "فحوصات الامتثال جارية حاليًا. سيتم إعادة المحاولة تلقائيًا — يرجى عدم إغلاق هذه النافذة.",
  onboarded_at: "تمت التهيئة في",
  device_uuid: "المعرف الفريد للجهاز (UUID)",
  expiring_in_days_one: "تنتهي الصلاحية خلال يوم واحد",
  expiring_in_days_other: "تنتهي الصلاحية خلال {{count}} يومًا",
  zatca_device_details: "تفاصيل جهاز ZATCA",
  zatca_device_detail_failed: "تعذر تحميل تفاصيل جهاز ZATCA.",
  registered_by: "مسجل بواسطة",
  invoices_count: "عدد الفواتير",
  csid_valid: "شهادة CSID صالحة",
  production_request_id: "رقم طلب الإنتاج",
  compliance_request_id: "رقم طلب الامتثال",
  last_pih: "آخر قيمة PIH",
  renew_now: "تجديد الآن",
  renew_csid: "تجديد شهادة CSID",
  zatca_csid_renewed_title: "تم تجديد CSID",
  zatca_csid_renewed_helper: "تم تجديد شهادة ZATCA CSID بنجاح.",
  zatca_csid_renew_failed: "تعذر تجديد شهادة CSID.",
  zatca_get_otp_helper:
    "افتح بوابة فاتورة، وقم بتوليد رمز تحقق OTP جديد، ثم أدخله هنا.",
  copy: "نسخ",
  copied: "تم النسخ",
  devices_cannot_submit_banner_one:
    "جهاز واحد ({{count}}) لا يمكنه إرسال الفواتير حتى يتم تجديده.",
  devices_cannot_submit_banner_other:
    "يوجد عدد {{count}} أجهزة لا يمكنها إرسال الفواتير حتى يتم تجديدها.",
  csid_expired_alert_helper:
    "انتهت صلاحية شهادة CSID هذه. قم بالتجديد الآن لمواصلة إرسال الفواتير إلى ZATCA.",
  pending_onboarding: "جاري التهيئة",
  compliance_pending: "فحص الامتثال معلق",
  compliance_passed: "اجتاز الامتثال",
  onboarding_in_progress: "التهيئة قيد التنفيذ",
  customer_type: "نوع العميل",
  buyer_name: "اسم المشتري",
  buyer_vat: "الرقم الضريبي للمشتري",
  buyer_company_address: "عنوان شركة المشتري",
  arabic_only_validation: "يُسمح بالأحرف العربية فقط",

  buyer_information: "معلومات المشتري",
  buyer_company_information: "معلومات المشتري / الشركة",
  zatca: "هيئة الزكاة والضريبة والجمارك (ZATCA)",

  invoices_last_7_days: "الفواتير — آخر 7 أيام",
  zatca_invoices_empty_default_filter:
    "لا توجد فواتير مرفوضة أو فاشلة في الفترة المحددة — وهذا أمر جيد.",
  uuid: "المعرف الفريد (UUID)",
  subtype: "النوع الفرعي",
  when: "الوقت",
  zatca_invoice_retry_attempt:
    "إعادة المحاولة خلال {{minutes}} دقيقة (المحاولة {{n}}/{{max}})",

  download_xml: "تحميل ملف XML الموقع",
  retry: "إعادة المحاولة",
  zatca_invoice_retry_disabled_helper:
    "طابور إعادة المحاولة لا يزال يعمل على هذه الفاتورة. تفتح إعادة المحاولة اليدوية فقط بعد {{max}} محاولات تلقائية.",
  zatca_invoice_retry_success: "تم وضع الفاتورة في طابور إعادة المحاولة.",
  zatca_invoice_retry_failed: "تعذر وضع هذه الفاتورة في طابور إعادة المحاولة.",
  zatca_invoice_xml_failed: "تعذر تحميل ملف XML الموقع.",

  // Status labels
  accepted: "مقبولة",
  accepted_with_warnings: "مقبولة (مع تحذيرات)",
  submitted: "مُرسلة",
  cleared: "مصدقة / تمت تصفيتها",
  reported: "مبلّغة",

  // Doc type / subtype labels
  invoice: "فاتورة",
  credit_note: "إشعار دائن",
  debit_note: "إشعار مدين",

  zatca_subtype_standard: "B2B (المدى القياسي / بين الشركات)",
  zatca_subtype_simplified: "B2C (المبسطة / للأفراد)",

  // ─── Invoice Detail Drawer ───────────────────────────────────────
  invoice_detail: "تفاصيل الفاتورة",
  zatca_errors: "أخطاء ZATCA",
  warnings: "التحذيرات",
  no_errors: "لا توجد أخطاء مسجلة من ZATCA.",
  no_warnings: "لا توجد تحذيرات.",
  icv: "عداد الفاتورة (ICV)",
  pih: "هاش الفاتورة السابقة (PIH)",
  transaction: "العملية",

  submitted_at: "أُرسلت في",
  zatca_invoice_qr_local: "رمز QR المحلي (المرحلة 2 TLV)",
  zatca_invoice_qr_zatca: "رمز QR لختم ZATCA (من ملف XML المصدّق)",

  // ─── CSID Expiry Banner (Home dashboard) ─────────────────────────
  zatca_csid_banner_expired_one:
    "انتهت صلاحية شهادة فرع {{branch}} منذ يوم واحد. لا يمكن إرسال الفواتير من هذا الفرع إلى ZATCA حتى يتم تجديدها.",
  zatca_csid_banner_expired_other:
    "انتهت صلاحية شهادة فرع {{branch}} منذ {{days}} أيام. لا يمكن إرسال الفواتير من هذا الفرع إلى ZATCA حتى يتم تجديدها.",
  zatca_csid_banner_expiring_red:
    "تنتهي صلاحية شهادة فرع {{branch}} خلال {{days}} أيام — قم بالتجديد الآن لتجنب التوقف عن العمل.",
  zatca_csid_banner_expiring_amber:
    "تنتهي صلاحية شهادة فرع {{branch}} خلال {{days}} أيام. خطط للتجديد قريبًا.",

  zatca_csid_banner_blocking_title:
    "لا يمكن لهذا الفرع إصدار فواتير ZATCA في الوقت الحالي",
  zatca_csid_banner_blocking_helper:
    "انتهت صلاحية شهادة CSID. يرجى تجديد الشهادة قبل إكمال أي عملية بيع في هذا الفرع.",

  // ─── Onboarding Wizard — new pieces ──────────────────────────────

  zatca_onboarding_compliance_failed:
    "فشلت بعض فحوصات الامتثال. يتم عرض رسائل خطأ ZATCA أدناه حرفيًا — يرجى نسخها عند الاتصال بالدعم.",

  // ─── Sale Screen — B2B clearance UX ──────────────────────────────

  zatca_sale_clearance_failed_title: "فشلت عملية تصديق ZATCA",
  zatca_sale_clearance_failed_helper:
    "ابدأ عملية جديدة. تم استخدام عداد الفواتير (ICV) لهذه المحاولة بالفعل ولا يمكن إعادة استخدامه.",
  zatca_sale_clearance_timeout_title: "انتهت مهلة تصديق ZATCA",
  zatca_sale_clearance_timeout_helper:
    "لا يمكن الوصول إلى نظام ZATCA. أعد المحاولة لنفس العملية، أو تراجع لإصدار إيصال B2C مبسط.",
  retry_clearance: "إعادة محاولة التصديق",
  clearance: "التخليص",
  reporting: "الإبلاغ",
  issue_b2c_instead: "إصدار إيصال B2C بدلاً من ذلك",
  start_new_transaction: "بدء عملية جديدة",

  // ─── Receipt — disclosure / verification ─────────────────────────

  zatca_invoice_rejected_alert: "تم رفض هذه الفاتورة من قبل ZATCA.",

  response_status: "حالة الاستجابة",
  billing_reference: "المرجع الفواتيري",
  invoice_hash: "هاش الفاتورة",
  responded_at: "تمت الاستجابة في",
  updated_at: "تم التحديث في",
  retry_count: "عدد محاولات الإعادة",
  next_retry_at: "المحاولة التالية في",
  compliance_check: "فحص الامتثال",

  same_cr_as_main_branch: "نفس السجل التجاري للفرع الرئيسي؟",
  validate_same_cr_required:
    "يرجى تحديد ما إذا كان هذا الفرع يستخدم نفس السجل التجاري.",

  select_cr_number: "تحديد رقم السجل التجاري",
  validate_name_or_phone_required: "الاسم أو رقم الهاتف مطلوب",
  use_existing_branch_zatca: "هل تريد استخدام تفاصيل ZATCA من فرع موجود؟",
  validate_use_existing_branch_zatca:
    "يرجى تحديد ما إذا كنت تريد إعادة استخدام تفاصيل ZATCA من فرع موجود.",
  add_new_cr_number: "أضف رقم سجل تجاري جديدًا لهذا الفرع",

  onboarded: "تمت التهيئة والربط",
  needs_reonboarding: "يحتاج لإعادة التهيئة",
  not_started: "لم تبدأ",
  in_progress: "قيد التنفيذ",
  zatca_reonboarding_confirm_title: "إعادة تهيئة ZATCA مطلوبة",
  zatca_reonboarding_confirm_message:
    "تحديث تفاصيل منشأة ZATCA سيتطلب تهيئة هذا الفرع وربطه مجددًا قبل إصدار فواتير متوافقة. هل تريد الاستمرار؟",

  use_existing_cr_number: "استخدم رقم السجل التجاري الحالي",
  select_zatca_cr_profile: "تحديد ملف تعريف السجل التجاري لـ ZATCA",
  validate_select_zatca_cr_profile:
    "يرجى تحديد ملف تعريف السجل التجاري لـ ZATCA.",
  zatca_cr_profile: "ملف تعريف السجل التجاري لـ ZATCA",
  branch_delete_zatca_history_error:
    "لا يمكن حذف الفرع لأنه يحتوي على فواتير ZATCA في سجله التاريخي.",
  requires_reonboarding_at: "يتطلب إعادة تهيئة في",
  stale_reason: "سبب عدم الصلاحية / القِدَم",
  zatca_reonboarding_required_title: "إعادة تهيئة ZATCA مطلوبة",
  zatca_reonboarding_required_helper:
    "تغيّر ملف تعريف السجل التجاري للبائع. يرجى إعادة تهيئة الجهاز المتأثر قبل إصدار فواتير متوافقة.",
  zatca_reonboarding_required_for_branch:
    "يتطلب فرع {{branch}} إعادة تهيئة ZATCA. السبب: {{reason}}.",

  zatca_status: "حالة ZATCA",
  zatca_branch_details: "تفاصيل فرع ZATCA",
  branch_information: "معلومات الفرع",
  branch_address_details: "تفاصيل عنوان الفرع",
  branch_address_details_helper:
    "عنوان الفرع الرسمي المستخدم في الفواتير ومستندات الفرع.",
  zatca_profile_details: "تفاصيل ملف تعريف ZATCA",
  company_id: "معرف المنشأة / الشركة",

  profile_completed: "ملف التعريف مكتمل",
  branches_count: "عدد الفروع",
  linked_branches: "الفروع المرتبطة",

  device_information: "معلومات الجهاز",
  zatca_information: "معلومات ZATCA",
  technical_information: "المعلومات التقنية",
  profile_id: "معرف ملف التعريف",
  version: "الإصدار",
  branch_zatca_profile_details: "تفاصيل ملف تعريف فرع ZATCA",
  active_lock_key: "مفتاح القفل النشط",
  csr_content: "محتوى ملف الـ CSR",
  compliance_csid: "شهادة الامتثال لـ CSID",
  production_csid: "شهادة الإنتاج لـ CSID",
  seller_information: "معلومات البائع",
  invoice_summary: "ملخص الفاتورة",
  amount_summary: "ملخص المبالغ",
  document_type: "نوع المستند",
  enter_otp: "أدخل OTP",
  otp: "OTP",
  employee: "موظف",
  owner: "المالك",
  selected: "محدد",
  download_slip_pdf: "تحميل الإيصال بصيغة PDF",
  kiosk: "الكشك",
  copy_failed: "فشل النسخ",
  dev_server: "خادم التطوير",
  qa_server: "خادم الاختبار",
  anypos_logo: "شعار AnyPOS",
  qr_code: "رمز QR",
  payment_processing: "جاري معالجة الدفع",
  success: "نجاح",
  loading: "جاري التحميل...",
  payment_type_mada: "نوع الدفع مدى",
  payment_type_visa: "نوع الدفع فيزا",
  payment_type_mastercard: "نوع الدفع ماستركارد",
  upload_units_categories_first: "يرجى رفع الوحدات والفئات أولاً.",
  failed_to_load_products: "فشل تحميل المنتجات",
  voice_connection_error: "خطأ في الاتصال الصوتي. يرجى المحاولة مرة أخرى.",
  voice_session_inactive:
    "تم إيقاف المساعد الصوتي بعد فترة من السكون. اضغط على الميكروفون للبدء من جديد.",
  voice_session_time_limit:
    "وصل المساعد الصوتي إلى الحد الزمني. اضغط على الميكروفون للبدء من جديد.",
  voice_agent_activated: "تم تفعيل المساعد الصوتي! ابدأ بالتحدث.",
  failed_to_start_voice_agent: "فشل تشغيل المساعد الصوتي.",
  failed_to_start_voice_agent_retry:
    "فشل تشغيل المساعد الصوتي. يرجى المحاولة مرة أخرى.",
  failed_to_load_order_history: "فشل تحميل سجل الطلبات",
  order_confirmed: "تم تأكيد الطلب",
  voice_assistant: "المساعد الصوتي",
  touch_screen: "شاشة لمس",
  ask_me_to_help_you_order: "اطلب مني مساعدتك في الطلب",
  ready: "جاهز",
  available_options: "الخيارات المتاحة:",
  report_invoice: "إرسال الفاتورة",
  clear_invoice: "تخليص الفاتورة",
  zatca_invoice_report_success: "تم إرسال فاتورة زاتكا",
  zatca_invoice_report_failed: "فشل إرسال فاتورة زاتكا",
  invoice_submitted_to_zatca: "تم إرسال الفاتورة إلى زاتكا.",
  bulk_report_b2c_invoices: "إرسال فواتير B2C دفعة واحدة",
  bulk_report_selected_b2c_confirm:
    "هل أنت متأكد أنك تريد إرسال {{count}} فاتورة B2C محددة إلى زاتكا؟",
  bulk_report_all_b2c_confirm:
    "لم يتم تحديد أي فاتورة. سيتم إرسال جميع فواتير B2C المعلقة أو الفاشلة للشركة. هل أنت متأكد؟",
  bulk_report_b2c_success: "تم بدء إرسال فواتير زاتكا دفعة واحدة",
  bulk_report_b2c_failed: "فشل بدء إرسال فواتير زاتكا دفعة واحدة",
  bulk_report_b2c_max_limit: "يمكنك تحديد 500 فاتورة كحد أقصى.",
  bulk_report_b2c_dispatched_count: "تم إرسال {{count}} فاتورة.",
  zatca_temporarily_unavailable: "زاتكا غير متاحة مؤقتًا",

  select_emoji: "اختر رمزًا تعبيريًا",
  emoji: "رمز تعبيري",

  // اكتمال الترجمة
  unexpected_error_description:
    "حدث خطأ غير متوقع. يرجى إعادة تحميل الصفحة والمحاولة مرة أخرى.",
  reload_page: "إعادة تحميل الصفحة",
  checkout_total_must_be_greater_than_zero:
    "يجب أن يكون المبلغ الإجمالي أكبر من صفر.",
  phone_number_example: "مثال: +966 5xxxxxxx",
  licenses_used_summary: "التراخيص المستخدمة: {{used}} من {{total}}",
  sold: "مباع",
  addition: "إضافة",
  subtraction: "طرح",
  multi_payment_cash: "الدفع المتعدد - نقدًا",
  multi_payment_card: "الدفع المتعدد - بطاقة",
  qr_order: "طلب عبر رمز QR",
  notifications: "الإشعارات",
  notification_sound_on: "صوت الإشعارات قيد التشغيل",
  notification_sound_off: "صوت الإشعارات متوقف",
  notification_sound_blocked:
    "حظر المتصفح صوت الإشعارات. انقر في أي مكان بالصفحة، أو أوقف الصوت ثم شغّله مرة أخرى.",
  notification_sound_failed:
    "تعذر تشغيل صوت الإشعارات. تحقق من مستوى صوت الجهاز.",
  mark_all_as_read: "قراءة الكل",
  no_notifications: "لا توجد إشعارات حتى الآن",
  new_pending_qr_order: "طلب QR جديد معلّق {{orderNumber}}",
  pending_qr_order_notification_details:
    "الطاولة {{table}} · المبلغ {{amount}}",
  table_management: "إدارة الطاولات",
  order_management: "إدارة الطلبات",
  waiter_management: "إدارة النُدُل",
  job_management: "إدارة المهام",
  stock_management: "إدارة المخزون",
  surepay: "Surepay",
  customer_management: "إدارة العملاء",
  error_in_row: "خطأ في الصف {{row}}: {{message}}",
  category_name_example: "برجر 🍔",
  transaction_reference: "مرجع المعاملة",
  payment_method: "طريقة الدفع",
  amount_received: "المبلغ المستلم",
  remaining: "المتبقي",
  buyer: "المشتري",
  transaction_code: "رمز العملية",
  issue_date: "تاريخ الإصدار",
  item: "الصنف",
  unit_price: "سعر الوحدة",
  printed_by_anypos: "تمت الطباعة بواسطة anypos.ai",
  order_source: "مصدر الطلب",
  job_employee: "موظف المهمة",
  refund_invoice: "فاتورة الاسترجاع",
  simplified_invoice: "فاتورة مبسطة",
  tax_invoice: "فاتورة ضريبية",
  simplified_tax_invoice: "فاتورة ضريبية مبسطة",
  refund_invoice_no: "رقم فاتورة الاسترداد",
  vat_exempt: "معفى من ضريبة القيمة المضافة",
  vat_total: "إجمالي ضريبة القيمة المضافة",
  total_taxable_excluding_vat:
    "الإجمالي الخاضع للضريبة (باستثناء ضريبة القيمة المضافة)",
  total_amount_due: "إجمالي المبلغ المستحق",
  verifying_with_zatca: "جارٍ التحقق من زاتكا…",
  rejected_by_zatca: "مرفوضة من زاتكا",
  error: "خطأ",
  warning: "تحذير",
  saudi_arabia: "المملكة العربية السعودية",

  // ─── Website Builder ──────────────────────────────────────────────
  website_appearance: "المظهر",
  website_brand: "العلامة التجارية",
  website_brand_help:
    "اختر لون العلامة التجارية الذي سيظهر على الموقع الإلكتروني",
  website_primary_colour: "لون أساسي",
  website_save_color: "حفظ اللون",
  website_color_saved: "تم حفظ اللون بنجاح",
  website_saved: "تم حفظ إعدادات الموقع بنجاح",
  website_banners: "البيانات الترويجية",
  website_add_banner: "إضافة بيانات ترويجية",
  website_edit_banner: "تعديل البيانات الترويجية",
  website_banner_title: "عنوان البيانات الترويجية",
  website_banner_title_placeholder: "مثال: اطلب وجبات طازجة عبر الإنترنت",
  website_banner_title_required: "عنوان البيانات الترويجية مطلوب",
  website_banner_label: "التصنيف",
  website_banner_label_placeholder: "مثال: جديد أو مميز",
  website_banner_description_placeholder: "أضف وصفًا مختصرًا",
  website_background_colour: "لون الخلفية",
  website_banner_icon: "الأيقونة",
  website_banner_image: "صورة البيان الترويجي",
  website_image_read_error: "تعذرت قراءة الصورة المحددة",
  website_about: "حول",
  website_section_heading: "العنوان الرئيسي",
  website_section_heading_placeholder: "مثال: نبذة عن نشاطنا",
  website_about_text: "نص حول الشركة",
  website_about_text_placeholder: "أخبر العملاء عن نشاطك التجاري",
  website_highlights: "أبرز النقاط",
  website_add_highlight: "إضافة نقطة بارزة",
  website_highlight_number: "النقطة البارزة {{number}}",
  website_highlight_placeholder: "أدخل ميزة أو فائدة رئيسية",
  phone_number_placeholder: "أدخل رقم الهاتف",
  email_placeholder: "أدخل البريد الإلكتروني",
  address_placeholder: "أدخل عنوان النشاط التجاري",
  website_contact: "التواصل",
  website_working_hours: "ساعات العمل",
  website_working_hours_help: "حدد وقت الفتح والإغلاق لكل يوم",
  website_day_sunday: "الأحد",
  website_day_monday: "الإثنين",
  website_day_tuesday: "الثلاثاء",
  website_day_wednesday: "الأربعاء",
  website_day_thursday: "الخميس",
  website_day_friday: "الجمعة",
  website_day_saturday: "السبت",
  website_open: "مفتوح",
  website_closed: "مغلق",
  website_to: "إلى",
  website_toggle_day: "تغيير التوفر ليوم {{day}}",
  website_open_time_for: "وقت الفتح ليوم {{day}}",
  website_close_time_for: "وقت الإغلاق ليوم {{day}}",
  website_social: "وسائل التواصل الاجتماعي",
  instagram: "إنستجرام",
  tiktok: "تيك توك",
  facebook: "فيسبوك",
  x: "X",
  website_branches: "الفروع",
  website_menu: "القائمة",
  website_builder_sections: "أقسام منشئ الموقع",
  website_tip_title: "نصيحة لون العلامة التجارية",
  website_tip_text:
    "اللون الذي تختاره هنا سيتم تطبيقه على عناصر مهمة مثل الأزرار والروابط والعناوين على موقعك الإلكتروني",
  website_hero_banners: "البيانات الترويجية الرئيسية",
  website_hero_banners_help:
    "أضف بيانات ترويجية جذابة في أعلى موقعك الإلكتروني",
  website_no_label: "بدون تصنيف",
  website_no_banners: "لم تتم إضافة بيانات ترويجية بعد",
  website_about_section: "قسم حول",
  website_about_help: "أخبر العملاء عن عملك والمنتجات والخدمات التي تقدمها",
  website_highlights_help: "أضف الميزات الرئيسية أو الفوائد لعملك",
  website_stats: "الإحصائيات (تظهر كبطاقات مميزة)",
  website_stats_help: "أضف الأرقام والعناوين التي تريد إبرازها عن عملك",
  website_stat_value: "قيمة الإحصائية {{number}}",
  website_stat_label: "عنوان الإحصائية {{number}}",
  website_stat_value_placeholder: "مثال: 50K+",
  website_stat_label_placeholder: "مثال: العملاء السعداء",
  website_contact_details: "معلومات التواصل",
  website_social_help:
    "أضف روابط التواصل الاجتماعي التي تريد عرضها على موقعك الإلكتروني",
  website_online_branches: "الفروع المتاحة",
  website_manage_branches: "إدارة الفروع",
  website_branches_help: "اختر الفروع التي تريد عرضها على موقعك الإلكتروني",
  website_no_branches: "لم يتم العثور على فروع",
  website_online_orders: "الطلبات الإلكترونية",
  website_menu_visibility: "ظهور القائمة",
  website_menu_help:
    "عاين قائمتك الإلكترونية وحدد المنتجات التي يمكن للعملاء رؤيتها.",
  website_menu_categories: "فئات القائمة",
  website_menu_visibility_help:
    "استخدم مفتاح كل منتج للتحكم في ظهوره على موقعك.",
  website_show_category: "إظهار الفئة على الموقع",
  website_hide_category: "إخفاء الفئة من الموقع",
  website_toggle_category: "تغيير ظهور {{category}} على الموقع",
  website_all_products: "كل المنتجات",
  website_show_all_products: "إظهار الكل",
  website_hide_all_products: "إخفاء الكل",
  website_grid_view: "عرض شبكي",
  website_list_view: "عرض القائمة",
  website_product_visibility_help:
    "اختر المنتجات التي تريد عرضها في متجر موقعك.",
  website_visible: "مرئي",
  website_hidden: "مخفي",
  website_visible_of_total: "{{count}} من {{total}} مرئي",
  website_manage_products: "إدارة المنتجات",
  website_products: "المنتجات",
  website_no_products: "لا توجد منتجات",
  website_no_categories: "لم يتم العثور على فئات",
  website_manage_menu: "إدارة القائمة",
  website_enabled: "مفعّل",
  website_disabled: "معطّل",
  website_on: "تشغيل",
  website_off: "إيقاف",
  choose_business: "اختر منشأة",
  choose_business_description: "اختر حساب المنشأة الذي تريد المتابعة به.",
  business_not_found: "المنشأة غير موجودة",
  business_not_found_description:
    "رابط هذه المنشأة غير موجود. تحقق من العنوان أو استخدم البوابة الرئيسية.",
  go_to_generic_portal: "الانتقال إلى البوابة الرئيسية",
  invalid_credentials: "رقم الهاتف أو كلمة المرور غير صحيحة.",
  store_url: "رابط المتجر",
  checking_store_url: "جارٍ التحقق من توفر الرابط...",
  store_url_available: "رابط المتجر هذا متاح.",
  store_url_taken: "رابط المتجر هذا مستخدم بالفعل.",
  store_url_invalid: "أدخل رابط متجر صالحًا.",
  store_url_suggestions: "اقتراحات",
  store_url_preview: "رابط متجرك",
  store_url_required: "رابط المتجر مطلوب.",
};

export default trans_ar;
